import type { ReactNode } from 'react';

type SectionProps = {
  title: string;
  children: ReactNode;
};

export function DetailSection({ title, children }: SectionProps) {
  return (
    <div className="flex w-full flex-col gap-3.5">
      <div className="flex w-full items-center gap-sm">
        <p className="text-body-xs whitespace-nowrap text-main opacity-50">{title}</p>
        <span className="h-px flex-1 bg-border"></span>
      </div>
      {children}
    </div>
  );
}

type FieldProps = {
  label: string;
  labelWidth?: string;
  children: ReactNode;
};

export function DetailField({ label, labelWidth = 'w-17', children }: FieldProps) {
  return (
    <div className="flex items-start text-body-xs">
      <p className={`shrink-0 text-heading-3xs text-placeholder ${labelWidth}`}>{label}</p>
      <div className="min-w-0 flex-1 text-main">{children}</div>
    </div>
  );
}
